import * as types from './types';
import { autoCompleteApiService } from '../../services/autocompleteApi';

export const getAutocomplete = () => dispatch => {
  return dispatch({
    type: types.GET_AUTOCOMPLETE,
    payload: autoCompleteApiService(),
  }).catch(err => console.log(err));
};

export const setAutocompleteForceRefresh = shouldForceRefresh => {
  return {
    type: types.AUTOCOMPLETE_FORCE_REFRESH,
    payload: shouldForceRefresh,
  };
};



// WEBPACK FOOTER //
// ./src/state/reducers/autocomplete/autocompleteActions.js